import React, { useState, useEffect } from 'react';
import { Heart, Sparkles, ChevronLeft, ChevronRight, Camera, Upload, Image } from 'lucide-react';
import './App.css';

// ============================================
// ✏️ CONFIGURACIÓN - EDITA AQUÍ TUS DATOS
// ============================================
const CONFIG = {
  nombreAmiga: "prissy",
  anosAmistad: 8,
  
  // Cada "recuerdo" puede tener múltiples fotos y una frase
  recuerdos: [
    {
      titulo: "prissy chiquita", // Título del recuerdo (opcional)
      frase: "desde pequeña ya te habias decidido en ser dora o wendy sulca",
      fotos: [
    "/fotos/niña/foto1.png",
    "/fotos/niña/foto2.png",
    "/fotos/niña/foto3.png",
    "/fotos/niña/foto4.png",
    "/fotos/niña/foto5.png"
  ]
    },
    {
      titulo: "tus anormalidades",
      frase: "No sé cómo lo hacías, pero cada vez que entraba a Discord ya estabas soltando alguna tonteria que me sacaba una risa. Al final, tus tonteras tenían más poder del que admito… siempre terminaban levantándome el día cuando más lo necesitaba. Gracias por ser así de anormal y hacerme reír tanto.",
      fotos: [
    "/fotos/boba/foto1.png",
    "/fotos/boba/foto2.png",
    "/fotos/boba/foto3.png",
    "/fotos/boba/foto4.png",
    "/fotos/boba/foto5.png",
    "/fotos/boba/foto6.png",
    "/fotos/boba/foto7.png",
    "/fotos/boba/foto8.png",
    "/fotos/boba/foto9.png",
    "/fotos/boba/foto10.png",
    "/fotos/boba/foto11.png",
    "/fotos/boba/foto12.png",
    "/fotos/boba/foto13.png",
    "/fotos/boba/foto14.png",
    "/fotos/boba/foto15.png"
      ]
    },
    {
      titulo: "dónde pisa una leona no borra la huella una gata",
      frase: "ya basta de poner fotos terribles tuyas eres una persona hermosa por dentro y por fuera me has ayudado tanto en estos años y me alegra tenerte en mi vida y orgullo de presumir una amiga tan guapa como tú",
      fotos: [
    "/fotos/linda/foto1.png",
    "/fotos/linda/foto2.png",
    "/fotos/linda/foto3.png",
    "/fotos/linda/foto4.png",
    "/fotos/linda/foto5.png",
    "/fotos/linda/foto6.png",
    "/fotos/linda/foto7.png",
    "/fotos/linda/foto8.png",
    "/fotos/linda/foto9.png",
    "/fotos/linda/foto10.png",
    "/fotos/linda/foto11.png",
    "/fotos/linda/foto12.png",
    "/fotos/linda/foto13.png",
    "/fotos/linda/foto14.png",
    "/fotos/linda/foto15.png"
      ]
    },
    {
      titulo: "rarete no?",
      frase: "ya sé que eres rara y eso me encanta de ti pero el blackface no esta bien \n\n la puta foto del pie sigue pesando 4 terabytes",
      fotos: [
      "/fotos/raro/foto1.png",
      "/fotos/raro/foto2.png",
      "/fotos/raro/foto3.png",
      "/fotos/raro/foto4.png"]
    },
    {
      titulo: "para finalizar",
      frase: "ya se que no soy la persona mas expresiva del mundo pero quiero que sepas que te aprecio mucho mas de lo que imaginas y se que la cage muchas veces en el pasado y no estve ahi para ti en algunos momentos y se que aveces me cuesta decir palabras bonitas o decirte lo mucho que me importas pero apesar de que mi sensibilidad este por los suelos tu eres una de las personas que mas quiero en este mundo y me siento muy afortunado de tenerte como amiga y espero que podamos seguir compartiendo muchos mas momentos juntos simplemente gracias por ser tú por soportarme por alegrarme el día por sacarme una sonrisa en mis peores días. Te quiero mucho prissy feliz cumpleaños ❤️ \n\nP.D: recuerda que seguimos casados, tienes que ser exitosa y rica para mantenerme",
      fotos: [
        "/fotos/raro/foto5.png"
      ]
    }
    // AÑADE TODOS TUS RECUERDOS AQUÍ
    // Cada recuerdo puede tener las fotos que quieras: 1, 2, 5, 10... ¡las que necesites!
  ],
  
  recuerdoEspecialIndex: 3, // Cuál recuerdo quieres destacar en la sección especial
  mensajeFinal: "Gracias por estos 8 años increíbles. Eres una de las mejores cosas que me ha dado la vida."
};
// ============================================

function App() {
  const [currentSection, setCurrentSection] = useState(0);
  const [currentPhotoInRecuerdo, setCurrentPhotoInRecuerdo] = useState({});
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showHearts, setShowHearts] = useState(false);
  const [uploadedPhotos, setUploadedPhotos] = useState({});

  const totalSections = CONFIG.recuerdos.length + 3;

  // Inicializar índices de fotos para cada recuerdo
  useEffect(() => {
    const initialIndices = {};
    CONFIG.recuerdos.forEach((_, index) => {
      initialIndices[index] = 0;
    });
    setCurrentPhotoInRecuerdo(initialIndices);
  }, []);

  const nextSection = () => {
    setImageLoaded(false);
    setCurrentSection((prev) => (prev + 1) % totalSections);
  };

  const prevSection = () => {
    setImageLoaded(false);
    setCurrentSection((prev) => (prev - 1 + totalSections) % totalSections);
  };

  const nextPhotoInRecuerdo = (recuerdoIndex) => {
  const recuerdo = CONFIG.recuerdos[recuerdoIndex];
  const newIndex = ((currentPhotoInRecuerdo[recuerdoIndex] || 0) + 1) % recuerdo.fotos.length;
  selectPhotoInRecuerdo(recuerdoIndex, newIndex);
};

  const prevPhotoInRecuerdo = (recuerdoIndex) => {
  const recuerdo = CONFIG.recuerdos[recuerdoIndex];
  const currentIndex = currentPhotoInRecuerdo[recuerdoIndex] || 0;
  const newIndex = (currentIndex - 1 + recuerdo.fotos.length) % recuerdo.fotos.length;
  selectPhotoInRecuerdo(recuerdoIndex, newIndex);
};

  const selectPhotoInRecuerdo = (recuerdoIndex, photoIndex) => {
  setCurrentPhotoInRecuerdo(prev => ({
    ...prev,
    [recuerdoIndex]: photoIndex
  }));
  setImageLoaded(false);
  
  // Scroll automático a la miniatura activa
  setTimeout(() => {
    const thumbnailContainer = document.querySelector('.thumbnails-container');
    const activeThumbnail = thumbnailContainer?.querySelectorAll('.thumbnail')[photoIndex];
    
    if (activeThumbnail && thumbnailContainer) {
      const containerWidth = thumbnailContainer.offsetWidth;
      const thumbnailLeft = activeThumbnail.offsetLeft;
      const thumbnailWidth = activeThumbnail.offsetWidth;
      
      // Centrar la miniatura en el contenedor
      const scrollPosition = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
      
      thumbnailContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }, 100);
};

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowRight') nextSection();
      if (e.key === 'ArrowLeft') prevSection();
      if (e.key === ' ') {
        e.preventDefault();
        setShowHearts(true);
        setTimeout(() => setShowHearts(false), 1000);
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [currentSection]);

  const handlePhotoUpload = (e, recuerdoIndex, photoIndex) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedPhotos(prev => ({
          ...prev,
          [`${recuerdoIndex}-${photoIndex}`]: e.target.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const FloatingHeart = ({ delay }) => (
    <Heart
      className="floating-heart"
      style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${delay}s`,
        width: `${20 + Math.random() * 30}px`,
        height: `${20 + Math.random() * 30}px`,
      }}
    />
  );

  const getTotalPhotos = () => {
    return CONFIG.recuerdos.reduce((total, recuerdo) => total + recuerdo.fotos.length, 0);
  };

  return (
    <div className="app-container">
      {showHearts && (
        <div className="hearts-container">
          {[...Array(20)].map((_, i) => (
            <FloatingHeart key={i} delay={i * 0.1} />
          ))}
        </div>
      )}

      {/* Hero Section */}
      {currentSection === 0 && (
        <div className="section hero-section">
          <div className="hero-content">
            <div className="sparkles-container">
              <Sparkles className="sparkles-icon" />
              <div className="sparkles-glow" />
            </div>
            
            <h1 className="hero-title">¡Feliz Cumpleaños!</h1>
            <h2 className="hero-name">{CONFIG.nombreAmiga}</h2>
            <p className="hero-subtitle">{CONFIG.anosAmistad} años de amistad increíble</p>
            <p className="hero-count">
              {CONFIG.recuerdos.length} recuerdos especiales · {getTotalPhotos()} fotos
            </p>
            
            <div className="hearts-row">
              <Heart className="heart-icon delay-0" />
              <Heart className="heart-icon delay-1" />
              <Heart className="heart-icon delay-2" />
            </div>
            
            <button onClick={nextSection} className="btn-primary">
              Comenzar el viaje ✨
            </button>
            
            <p className="hint-text">💡 Presiona espacio para ver corazones</p>
          </div>
        </div>
      )}

      {/* Recuerdos Sections */}
      {currentSection > 0 && currentSection <= CONFIG.recuerdos.length && (() => {
        const recuerdoIndex = currentSection - 1;
        const recuerdo = CONFIG.recuerdos[recuerdoIndex];
        const currentPhotoIndex = currentPhotoInRecuerdo[recuerdoIndex] || 0;
        const currentPhoto = recuerdo.fotos[currentPhotoIndex];
        
        return (
          <div className="section photo-section" key={recuerdoIndex}>
            <div className="photo-container">
              <div className="photo-card">
                <div className="photo-grid">
                  {/* Photo Column */}
                  <div className="photo-column">
                    <div 
                      className="photo-wrapper"
                      onMouseEnter={(e) => {
                        if (recuerdo.fotos.length > 1) {
                          e.currentTarget.querySelector('.photo-nav-overlay').style.opacity = '1';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (recuerdo.fotos.length > 1) {
                          e.currentTarget.querySelector('.photo-nav-overlay').style.opacity = '0';
                        }
                      }}
                    >
                      {!imageLoaded && (
                        <div className="loading-spinner">
                          <div className="spinner"></div>
                        </div>
                      )}
                      <img
                        src={uploadedPhotos[`${recuerdoIndex}-${currentPhotoIndex}`] || currentPhoto}
                        alt={`${recuerdo.titulo} - Foto ${currentPhotoIndex + 1}`}
                        className={`photo-img ${imageLoaded ? 'loaded' : ''}`}
                        onLoad={() => setImageLoaded(true)}
                      />
                      
                      {/* Photo navigation overlay */}
                      {recuerdo.fotos.length > 1 && (
                        <div className="photo-nav-overlay">
                          <button
                            onClick={() => prevPhotoInRecuerdo(recuerdoIndex)}
                            className="photo-nav-btn photo-nav-left"
                          >
                            <ChevronLeft size={24} />
                          </button>
                          <button
                            onClick={() => nextPhotoInRecuerdo(recuerdoIndex)}
                            className="photo-nav-btn photo-nav-right"
                          >
                            <ChevronRight size={24} />
                          </button>
                        </div>
                      )}
                      
                      {/* Photo counter badge */}
                      {recuerdo.fotos.length > 1 && (
                        <div className="photo-count-badge">
                          <Image size={16} />
                          <span>{currentPhotoIndex + 1} / {recuerdo.fotos.length}</span>
                        </div>
                      )}
                    </div>
                    
                    {/* Thumbnails */}
                    {recuerdo.fotos.length > 1 && (
                      <div className="thumbnails-container">
                        {recuerdo.fotos.map((foto, idx) => (
                          <button
                            key={idx}
                            onClick={() => selectPhotoInRecuerdo(recuerdoIndex, idx)}
                            className={`thumbnail ${idx === currentPhotoIndex ? 'active' : ''}`}
                          >
                            <img
                              src={uploadedPhotos[`${recuerdoIndex}-${idx}`] || foto}
                              alt={`Miniatura ${idx + 1}`}
                            />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Text Column */}
                  <div className="text-column">
                    {recuerdo.titulo && (
                      <h3 className="recuerdo-titulo">{recuerdo.titulo}</h3>
                    )}
                    
                    <div className="quote-mark">"</div>
                    <p className="photo-text">{recuerdo.frase}</p>
                    
                    <div className="photo-info">
                      <div className="info-row">
                        <div className="photo-counter">
                          <Camera className="icon-sm" />
                          <span>Recuerdo {currentSection} / {CONFIG.recuerdos.length}</span>
                        </div>
                        <button
                          onClick={() => {
                            setShowHearts(true);
                            setTimeout(() => setShowHearts(false), 1000);
                          }}
                          className="btn-heart"
                        >
                          <Heart className="icon-md heart-fill" />
                        </button>
                      </div>
                      
                      <div className="progress-bar">
                        <div 
                          className="progress-fill"
                          style={{ width: `${(currentSection / CONFIG.recuerdos.length) * 100}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="navigation">
                <button onClick={prevSection} className="btn-nav">
                  <ChevronLeft className="icon-sm" />
                  Anterior
                </button>

                <div className="mini-gallery">
                  {CONFIG.recuerdos.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentSection(idx + 1)}
                      className={`section-dot ${currentSection === idx + 1 ? 'active' : ''}`}
                    />
                  ))}
                </div>

                <button onClick={nextSection} className="btn-nav btn-next">
                  Siguiente
                  <ChevronRight className="icon-sm" />
                </button>
              </div>

              <p className="navigation-hint">
                {recuerdo.fotos.length > 1 
                  ? `${recuerdo.fotos.length} fotos en este recuerdo · Navega con las flechas sobre la imagen`
                  : 'Usa ← → para cambiar de recuerdo | Presiona ❤️ para mostrar amor'
                }
              </p>
            </div>
          </div>
        );
      })()}

      {/* Special Memory Section */}
      {currentSection === CONFIG.recuerdos.length + 1 && (() => {
        const recuerdoEspecial = CONFIG.recuerdos[CONFIG.recuerdoEspecialIndex];
        const photoIndex = currentPhotoInRecuerdo[CONFIG.recuerdoEspecialIndex] || 0;
        
        return (
          <div className="section special-section">
            <div className="special-container">
              <div className="special-header">
                <Sparkles className="sparkles-icon-sm" />
                <h2 className="special-title">Un Recuerdo Muy Especial</h2>
                <p className="special-subtitle">Este momento significa mucho para mí</p>
              </div>

              <div className="special-card">
                <div className="special-grid">
                  <div>
                    <div className="special-photo-wrapper">
                      <div className="special-photo">
                        <img
                          src={uploadedPhotos[`special-${photoIndex}`] || recuerdoEspecial.fotos[photoIndex]}
                          alt="Foto especial"
                        />
                      </div>
                      
                      <div className="upload-overlay">
                        <label className="btn-upload">
                          <Upload className="icon-sm" />
                          Cambiar foto
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handlePhotoUpload(e, 'special', photoIndex)}
                            style={{ display: 'none' }}
                          />
                        </label>
                      </div>
                    </div>
                    
                    {recuerdoEspecial.fotos.length > 1 && (
                      <div className="special-thumbnails">
                        {recuerdoEspecial.fotos.map((foto, idx) => (
                          <button
                            key={idx}
                            onClick={() => selectPhotoInRecuerdo(CONFIG.recuerdoEspecialIndex, idx)}
                            className={`thumbnail ${idx === photoIndex ? 'active' : ''}`}
                          >
                            <img src={foto} alt={`Mini ${idx + 1}`} />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="special-text">
                    {recuerdoEspecial.titulo && (
                      <h3 className="recuerdo-titulo">{recuerdoEspecial.titulo}</h3>
                    )}
                    <div className="quote-mark">"</div>
                    <p className="special-frase">{recuerdoEspecial.frase}</p>
                    <div className="special-badge">
                      <Heart className="icon-sm heart-fill heart-pulse" />
                      <span>Mi recuerdo favorito</span>
                    </div>
                    <p className="special-hint">
                      {recuerdoEspecial.fotos.length > 1 ? 'Selecciona una foto diferente abajo' : 'Pasa el mouse sobre la foto para cambiarla'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="special-navigation">
                <button onClick={prevSection} className="btn-nav">
                  ← Volver
                </button>
                <button onClick={nextSection} className="btn-nav btn-next">
                  Continuar →
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Final Message */}
      {currentSection === CONFIG.recuerdos.length + 2 && (
        <div className="section final-section">
          <div className="final-content">
            <div className="sparkles-container">
              <Sparkles className="sparkles-icon" />
              <div className="sparkles-glow" />
            </div>
            
            <h2 className="final-title">Gracias por todo</h2>
            <p className="final-message">{CONFIG.mensajeFinal}</p>
            <p className="final-stats">
              {CONFIG.recuerdos.length} recuerdos · {getTotalPhotos()} fotos · {CONFIG.anosAmistad} años · Infinitos momentos
            </p>
            
            <div className="final-hearts">
              {[...Array(5)].map((_, i) => (
                <Heart 
                  key={i} 
                  className="final-heart" 
                  style={{ animationDelay: `${i * 0.2}s` }} 
                />
              ))}
            </div>
            
            <button onClick={() => setCurrentSection(0)} className="btn-primary">
              Ver de nuevo 🎉
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;